module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0004.jpg?v=29b3ea75";